import {
    ContextMenu,
    ContextMenuContent,
    ContextMenuItem,
    ContextMenuShortcut,
    ContextMenuTrigger,
} from "@/Components/ui/context-menu"
import { PlanBuilderContext } from "../Plan";
import { useContext } from "react";
import { PageLockContext } from "@/Components/PageLockProvider";
import React from "react";
import { CheckIcon, DeleteIcon, EditIcon} from "@/Components/ui/Icons/TooltipIcon";

interface WorkPackageContextMenuProps {
    children?: React.ReactNode;
}

export function WorkPackageContextMenu({ children }: WorkPackageContextMenuProps) {
    const lock = useContext(PageLockContext);
    const plan = useContext(PlanBuilderContext);

    const handleOpenChange = (isOpen: boolean) => {        
        if (!isOpen) return;
    };

    function handleDeleteWorkPackage() {
        if (!plan.selectedWorkpackageID) return;       
        // Use setTimeout to ensure the menu closes before deletion starts
        setTimeout(() => {
            plan.confirmDeleteWorkPackage(plan.selectedWorkpackageID!);
        }, 0);
    }

    function handleCompleteAllTasks() {
        if (!plan.selectedWorkpackageID) return;
         const workPackage = plan.getWorkPackageById(plan.selectedWorkpackageID!);
        if (!workPackage) return;
        
        const taskIds = workPackage.tasks.map(task => task.id);
        if (!taskIds) return;
        plan.completeMultipleTasks(taskIds);
    }

    return (
        <ContextMenu onOpenChange={handleOpenChange}>
            <ContextMenuTrigger>{children}</ContextMenuTrigger>
            <ContextMenuContent className="w-64">
                <ContextMenuItem onClick={() => handleCompleteAllTasks()} disabled={!plan.selectedWorkpackageID || lock.viewOnly}>
                    <CheckIcon />{"Complete All Tasks"}
                    <ContextMenuShortcut>Alt + E</ContextMenuShortcut>
                </ContextMenuItem>
                <ContextMenuItem onClick={() => plan.setShowEditForm(true)} disabled={!plan.selectedWorkpackageID || lock.viewOnly}>
                    <EditIcon />{"Edit Work Package"}
                    <ContextMenuShortcut>Alt + E</ContextMenuShortcut>
                </ContextMenuItem>
                <ContextMenuItem disabled={!plan.selectedWorkpackageID || lock.viewOnly} onClick={() => handleDeleteWorkPackage()}>
                    <DeleteIcon />{"Delete Work Package"}
                    <ContextMenuShortcut>Alt + D</ContextMenuShortcut>
                </ContextMenuItem>
            </ContextMenuContent>
        </ContextMenu>
    )
}